import { useAbExperimentBucket } from 'hooks/abExperiment/useAbExperimentBucket';
import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import { searchFacetsJob } from 'modules/search/constants/searchFacetsJob';
import { SearchPage } from 'modules/search/pages/Search/SearchPage';

export function SearchJobsPage() {
  useSetDocumentTitle(
    /* TRANSLATORS: job search page title */
    getText('Find Jobs Near You'),
  );

  const [bucketValue] = useAbExperimentBucket(
    'SPLIT_SCREEN_SEARCH_INACTIVE_2024_12',
  );

  return (
    <SearchPage
      noSidebar={bucketValue === 'ENABLED'}
      searchType="JOB"
      searchFacets={searchFacetsJob}
      allowAds
    />
  );
}
